module.exports = __webpack_public_path__ + "static/media/grad2.663e7256.PNG";